module.exports = __webpack_public_path__ + "static/media/img1-1.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/nutricheck_foliar/N/img1-1.png
// module id = 2249
// module chunks = 3